// extracted by mini-css-extract-plugin
module.exports = {"price":"price-1WKvY","charge":"charge-2PmFe","total":"total-2qsl1","header__name":"header__name-3T3nl","taxesTooltip":"taxesTooltip-2ggNU","flight":"flight-f4929"};